export type HistoryKind = 'rewardPoints' | 'prizeCredits' | 'zPoints' | 'timedPoints' | 'assets';
export type MemberPage =
  | 'card'
  | 'history'
  | 'details'
  | 'profile-help'
  | 'venue'
  | 'booking'
  | 'reservations'
  | 'line'
  | 'redeem'
  | 'redemptions'
  | 'wallet'
  | 'draws'
  | 'wip'
  | 'inbox'
  | 'notification-preferences'
  | 'service-history';
type NavigationItem = 'card' | 'booking' | 'tickets' | 'details';
export interface MemberDestination {
  assetTypeId?: string;
  page: MemberPage;
  nav: NavigationItem;
  feature?: string;
  historyKind?: HistoryKind;
  barcode?: boolean;
  walletKind?: 'package' | 'voucher' | 'plan';
}

export const memberNavigation = [
  { route: 'card', label: '會員中心' },
  { route: 'booking', label: '預約' },
  { route: 'tickets', label: '票券' },
  { route: 'details', label: '會員資料' },
] as const;

export const memberServices = [
  { route: 'booking', label: '預約賽事', nav: 'booking' },
  { route: 'reservations', label: '預約紀錄', nav: 'booking' },
  { route: 'tickets', label: '我的票券', nav: 'tickets' },
  { route: 'class-tickets', label: '我的堂票', nav: 'tickets' },
  { route: 'redeem', label: '兌換中心', nav: 'card' },
  { route: 'redemptions', label: '兌換紀錄', nav: 'card' },
  { route: 'referral', label: '推薦好友', nav: 'card' },
  { route: 'draws', label: '活動抽選紀錄', nav: 'card' },
  { route: 'service-history', label: '服務歷程', nav: 'details' },
] as const;

const home: MemberDestination = { page: 'card', nav: 'card' };
const profile: MemberDestination = { page: 'details', nav: 'details' };
const destinations: Record<string, MemberDestination> = {
  card: home,
  'card/barcode': { ...home, barcode: true },
  history: { page: 'history', nav: 'card' },
  points: { page: 'history', nav: 'card', historyKind: 'prizeCredits' },
  'points/reward': { page: 'history', nav: 'card', historyKind: 'rewardPoints' },
  'points/z': { page: 'history', nav: 'card', historyKind: 'zPoints' },
  'points/timed': { page: 'history', nav: 'card', historyKind: 'timedPoints' },
  details: profile,
  profile,
  'profile/line': { page: 'line', nav: 'details' },
  'profile/venue': { page: 'venue', nav: 'details' },
  'profile/edit': { page: 'profile-help', nav: 'details' },
  tournaments: { page: 'wip', nav: 'card', feature: '賽事活動' },
  news: { page: 'wip', nav: 'card', feature: '最新活動' },
  social: { page: 'wip', nav: 'card', feature: '社群媒體' },
  access: { page: 'wip', nav: 'card', feature: '交通資訊' },
};
for (const entry of memberServices) {
  destinations[entry.route] =
    entry.route === 'draws'
      ? { page: 'draws', nav: 'card' }
      : { page: 'wip', nav: entry.nav, feature: entry.label };
}
destinations.redeem = { page: 'redeem', nav: 'card' };
destinations.redemptions = { page: 'redemptions', nav: 'card' };
destinations.booking = { page: 'booking', nav: 'booking' };
destinations.reservations = { page: 'reservations', nav: 'booking' };
destinations.reserve = destinations.booking;
destinations.tickets = { page: 'wallet', nav: 'tickets', walletKind: 'voucher' };
destinations['class-tickets'] = { page: 'wallet', nav: 'tickets', walletKind: 'package' };
destinations.inbox = { page: 'inbox', nav: 'details' };
destinations['notification-preferences'] = { page: 'notification-preferences', nav: 'details' };
destinations['service-history'] = { page: 'service-history', nav: 'details' };

// Hash-only navigation preserves the page's immutable venue and LIFF profile.
export function memberDestination(hash: string): MemberDestination {
  const route = hash.replace(/^#\/?/, '').replace(/\/$/, '');
  const asset =
    /^points\/assets\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i.exec(route);
  if (asset) return { page: 'history', nav: 'card', historyKind: 'assets', assetTypeId: asset[1] };
  return Object.hasOwn(destinations, route) ? destinations[route]! : home;
}
